<ng-container *ngIf="isDisabled; then readonly; else editing"></ng-container>

<ng-template #readonly>
  <nb-form-field>
    <input nbInput
           type="text"
           placeholder="Team suchen"
           [ngModel]="getTeamTitle(value)"
           fullWidth
           [disabled]="true" />
    <button nbSuffix
            nbButton
            ghost
            *ngIf="value"
            (click)="goToTeam()"
            nbTooltip="Zum Team">
      <nb-icon icon="external-link-outline"
               pack="eva">
      </nb-icon>
    </button>
  </nb-form-field>
</ng-template>

<ng-template #editing>
  <nb-form-field>
    <input nbInput
           type="text"
           #searchInput
           [ngModel]="getTeamTitle(value)"
           (ngModelChange)="filterText$.next($event);trigger$.next('reset')"
           placeholder="Team suchen"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           fullWidth/>
    <button *ngIf="value" nbSuffix nbButton ghost (click)="clear()">
      <nb-icon icon="close-outline"
               pack="eva">
      </nb-icon>
    </button>
  </nb-form-field>

  <ng-template #popoverTemplate>
    <div class="autocomplete-dropdown">
      <nb-list nbInfiniteList (bottomThreshold)="trigger$.next('loadMore')" [threshold]="50" [throttleTime]="100">
        <nb-list-item *ngFor="let team of teams$ | async; trackBy: trackById" (click)="onSelectionChange(team)">
          <div class="team">
            <div class="name">{{ team.name }}</div>
            <div class="team-meta-info">{{ team.tenant.name }}</div>
            <div class="team-meta-info" *ngIf="team.region; else noRegion">{{ team.region.name }}</div>
          </div>
        </nb-list-item>
      </nb-list>
    </div>
  </ng-template>
</ng-template>

<ng-template #noRegion>
  <div class="team-meta-info">Kein Bereich</div>
</ng-template>
